import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";

import {
  LandingNav,
  HeroSection,
  VideoDemoSection,
  HowItWorksSection,
  BenefitsSection,
  ProofSection,
  FoundingMembersSection,
  InlinePricingSection,
  TrustSection,
  TechProofSection,
  SecuritySection,
  IntegrationsBarSection,
  FinalClosingSection,
  NewsletterSection,
  LandingFooter,
  VideoModal,
} from "../components/landing";

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function LandingPage() {
  const [showVideo, setShowVideo] = useState(false);
  const [foundingStatus, setFoundingStatus] = useState(null);
  const { user, logout, hasActiveSubscription } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_URL}/billing/founding-status`)
      .then(res => setFoundingStatus(res.data))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white relative landing-section">
      <LandingNav user={user} navigate={navigate} hasActiveSubscription={hasActiveSubscription} logout={logout} />
      <main id="main-content">

      {/* Funnel: Hero → Video → How It Works → Benefits → Founding Members → Pricing → Trust */}
      <HeroSection navigate={navigate} user={user} />
      <VideoDemoSection setShowVideo={setShowVideo} navigate={navigate} />
      <HowItWorksSection navigate={navigate} />
      <BenefitsSection navigate={navigate} />
      <ProofSection />
      <FoundingMembersSection foundingStatus={foundingStatus} navigate={navigate} />
      <InlinePricingSection foundingStatus={foundingStatus} navigate={navigate} />
      <TrustSection />
      <TechProofSection />
      <SecuritySection />
      <IntegrationsBarSection />
      <NewsletterSection />
      <FinalClosingSection navigate={navigate} />
      </main>
      <LandingFooter />

      <VideoModal showVideo={showVideo} setShowVideo={setShowVideo} />
    </div>
  );
}
